import { render } from "./SavePlanButtons.vue?vue&type=template&id=130ab0a3"
import script from "./SavePlanButtons.vue?vue&type=script&lang=js"
export * from "./SavePlanButtons.vue?vue&type=script&lang=js"

import exportComponent from "/usr/src/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__